import { render, staticRenderFns } from "./ProductUploads.vue?vue&type=template&id=7f127db9"
import script from "./ProductUploads.vue?vue&type=script&lang=js"
export * from "./ProductUploads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports